import { Card, FormGroup, InputWithUnit } from '../ui/Card';
import { fmt } from '../../lib/format';
import type { CalculatorInputs } from '../../lib/types';

interface Props {
  inputs: CalculatorInputs;
  updateInput: <K extends keyof CalculatorInputs>(key: K, value: CalculatorInputs[K]) => void;
  collapsible?: boolean;
  summary?: string;
  isOpen?: boolean;
  onToggle?: () => void;
}

export function IncomeCard({ inputs, updateInput, collapsible, summary, isOpen, onToggle }: Props) {
  const grossMonthly = inputs.grossAnnualIncome / 12;

  return (
    <Card title="Income & Monthly Debts" collapsible={collapsible} summary={summary} isOpen={isOpen} onToggle={onToggle}>
      <div className="form-row">
        <FormGroup label="Gross Annual Income">
          <InputWithUnit
            unit="$"
            value={inputs.grossAnnualIncome}
            onChange={v => updateInput('grossAnnualIncome', v)}
            min={0}
            step={5000}
          />
        </FormGroup>
        <FormGroup label="Gross Monthly Income">
          <InputWithUnit
            unit="$"
            value={grossMonthly > 0 ? fmt(grossMonthly) : ''}
            onChange={() => {}}
            readOnly
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup label="Car Payments">
          <InputWithUnit
            unit="$"
            value={inputs.monthlyCarPayment}
            onChange={v => updateInput('monthlyCarPayment', v)}
            min={0}
            step={50}
          />
        </FormGroup>
        <FormGroup label="Student Loans">
          <InputWithUnit
            unit="$"
            value={inputs.monthlyStudentLoans}
            onChange={v => updateInput('monthlyStudentLoans', v)}
            min={0}
            step={50}
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup label="Credit Card Min. Payments">
          <InputWithUnit
            unit="$"
            value={inputs.monthlyCreditCards}
            onChange={v => updateInput('monthlyCreditCards', v)}
            min={0}
            step={25}
          />
        </FormGroup>
        <FormGroup label="Other Monthly Debt">
          <InputWithUnit
            unit="$"
            value={inputs.monthlyOtherDebt}
            onChange={v => updateInput('monthlyOtherDebt', v)}
            min={0}
            step={50}
          />
        </FormGroup>
      </div>
    </Card>
  );
}
